import { connect } from 'react-redux';
import { getCollectionZips, placeDeliverOrder, setDeliverError } from 'Favourites/store/actions';
import { selectProducts } from 'Favourites/store/reducers/data/products';

import {
    selectZips,
    selectError,
} from 'store/reducers/data/clickDeliver';

import { selectIsFormProcessing } from 'Favourites/store/reducers';
import * as forms from 'Favourites/store/constants/formTypes';
import { getText } from 'helpers/i18n';

const mapStateToProps = (state) => {
    return {
        zips: selectZips(state),
        products: selectProducts(state),
        error: selectError(state) ? getText('clickcollect_error_' + selectError(state)) : false,
        processing: selectIsFormProcessing(state, forms.ClickDeliver),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCollectionZips: () => {
            dispatch(getCollectionZips());
        },
        placeDeliverOrder: (zip, products) => {
            dispatch(setDeliverError(''));
            dispatch(placeDeliverOrder(zip, products));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
